import "./FAQ.module.css";
import Header from "@/reusable_sections/Header";
import FrequentlyAskedQuestions from "./sections/FrequentlyAskedQuestions";
import SmartHomeSystemIntegration from "./sections/SmartHomeSystemIntegration";
import ContactUs from "./sections/ContactUs";
import Footer from "@/reusable_sections/Footer";
export default function FAQPage() {
  return <div>
      <Header />
      <FrequentlyAskedQuestions />
      <SmartHomeSystemIntegration />
      <ContactUs />
      <Footer />
    </div>;
}